import { generatePath } from '@helpers';
import { z } from 'zod';

const watchlistSummarySchema = z.object({
  summary: z.string(),
});

const dailyBriefQuestionDrawerParamsSchema = z.record(z.string(), z.string());

const dailyBriefQuestionContextInlineSchema = z.object({
  text: z.string(),
  sourceNumber: z.number().optional(),
  sourceType: z.string().optional(),
  sourceId: z.string().optional(),
  drawerParams: dailyBriefQuestionDrawerParamsSchema.optional(),
});

const dailyBriefQuestionSourceSchema = z.object({
  sourceNumber: z.number(),
  sourceType: z.string(),
  insightType: z.string().optional(),
  sourceId: z.string(),
  title: z.string().optional(),
  drawerParams: dailyBriefQuestionDrawerParamsSchema.optional(),
});

const dailyBriefQuestionSchema = z.object({
  sectionTitle: z.string(),
  subsectionTitle: z.string(),
  watchlistId: z.string(),
  watchlistIds: z.array(z.string()).optional(),
  dedupeKey: z.string().optional(),
  question: z.string().optional(),
  questionContext: z.string(),
  questionContextInlines: z
    .array(dailyBriefQuestionContextInlineSchema)
    .optional(),
  sources: z.array(dailyBriefQuestionSourceSchema).optional(),
});

const dailyBriefQuestionListSchema = z.array(dailyBriefQuestionSchema);

const dailyBriefQuestionsSchema = z.object({
  questions: dailyBriefQuestionListSchema,
});

const dailyBriefResponseSchema = z.object({
  status: z.string(),
});

export const watchlistSummary = {
  getWatchlistSummary: {
    path: (watchlistId: string) => `watchlist-summary/v1/${watchlistId}`,
    schema: watchlistSummarySchema,
  },
  getDailyBriefQuestions: {
    path: (watchlistId?: string) => {
      const path = 'watchlist-summary/v1/daily-brief/questions';

      if (!watchlistId) {
        return path;
      }

      return generatePath({
        basePath: path,
        params: { id: watchlistId },
      });
    },
    schema: dailyBriefQuestionsSchema,
  },
};

export type WatchlistSummary = z.infer<typeof watchlistSummarySchema>;
export type DailyBriefQuestion = z.infer<typeof dailyBriefQuestionSchema>;
export type DailyBriefQuestionDrawerParams = z.infer<
  typeof dailyBriefQuestionDrawerParamsSchema
>;
export type DailyBriefQuestionSource = z.infer<
  typeof dailyBriefQuestionSourceSchema
>;
export type DailyBriefQuestions = z.infer<typeof dailyBriefQuestionListSchema>;
export type DailyBriefQuestionsResponse = z.infer<
  typeof dailyBriefQuestionsSchema
>;
export type DailyBriefResponse = z.infer<typeof dailyBriefResponseSchema>;
